import { render, staticRenderFns } from "./UmbrellaMenu.vue?vue&type=template&id=0fc9767d"
import script from "./UmbrellaMenu.vue?vue&type=script&lang=ts"
export * from "./UmbrellaMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports